/* eslint-disable no-nested-ternary */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useWindowSize } from "@qgiv/core-react";
import { Modal2 } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";
import TeamModalFooter from "./common/TeamModalFooter";
import ConnectedCreateTeamNav from "./ConnectedCreateTeamNav";
import { CREATE_TEAM, JOIN_TEAM } from "./constants/views";
import ModalStateContext from "./ModalStateContext";
import { CreateTeamView, JoinTeamView } from "./Views";
import "./TeamModalContent.scss";

const TeamModalContent = ({
    currentRegistration,
    hasSelectedTeam,
    setFieldValue,
    teamModalOpen,
    setAppTeamModalOpen,
}) => {
    const dispatch = useDispatch();
    const { activeView, setActiveView } = React.useContext(ModalStateContext);
    // If the modal is opened on mobile and used horizontally the modal gets cut off
    // and Save Team button is not accessible, we need to allow scroll in such a case
    const windowSize = useWindowSize();
    const { width, height } = windowSize;
    const horizontalMobile = width > height && height < 550;

    useEffect(() => {
        if (currentRegistration > 0 && activeView === CREATE_TEAM) {
            setActiveView(JOIN_TEAM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentRegistration]);
    // New_Team_Name and the New_Team_Fundraising_Goal values are not wiped
    // after a user exits the modal without saving. This makes it easier for
    // the user to create a team if they previously closed the modal and the BE
    // will not process this data if the user decided to join a team or
    // register as an individual later on
    const handleTeamModalCloseClick = () => {
        if (!hasSelectedTeam) {
            setFieldValue("Registration_Role", []);
        }
        dispatch(setAppTeamModalOpen(false));
    };

    return (
        teamModalOpen && (
            <Modal2
                onClose={handleTeamModalCloseClick}
                renderFooter={() => <TeamModalFooter />}
                scrollOverflow={
                    !!(activeView === CREATE_TEAM || horizontalMobile)
                }
            >
                {activeView === CREATE_TEAM && <ConnectedCreateTeamNav />}
                <div className="team-modal-content">
                    {activeView === JOIN_TEAM ? (
                        <JoinTeamView />
                    ) : activeView === CREATE_TEAM ? (
                        <CreateTeamView />
                    ) : null}
                </div>
            </Modal2>
        )
    );
};

TeamModalContent.propTypes = {
    currentRegistration: PropTypes.number.isRequired,
    teamModalOpen: PropTypes.bool.isRequired,
    setAppTeamModalOpen: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    hasSelectedTeam: PropTypes.bool.isRequired,
};

export default TeamModalContent;
